import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';
import authService from '../services/authService';
import orgService from '../services/orgService';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showUserDropdown, setShowUserDropdown] = useState<boolean>(false);
  const userMenuRef = useRef<HTMLDivElement>(null);

  const toggleUserDropdown = (): void => {
    setShowUserDropdown(!showUserDropdown);
  };

  // Close dropdown when clicking outside the menu
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (showUserDropdown && userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
        setShowUserDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showUserDropdown]);

  // Close dropdown when navigating (e.g. from sidebar or any route change)
  useEffect(() => {
    setShowUserDropdown(false);
  }, [location.pathname]);

  const handleLogout = (): void => {
    setShowUserDropdown(false);
    authService.logout();
    navigate('/login');
  };

  const handleSettings = (): void => {
    setShowUserDropdown(false);
    navigate('/dashboard/settings');
  };

  const handleChangePassword = (): void => {
    setShowUserDropdown(false);
    navigate('/dashboard/change-password');
  };

  const handleUserManagement = (): void => {
    setShowUserDropdown(false);
    navigate('/dashboard/user-management');
  };

  const handleManageOrganizations = (): void => {
    setShowUserDropdown(false);
    navigate('/dashboard/manage-organizations');
  };

  const handleTypeMapping = (): void => {
    setShowUserDropdown(false);
    navigate('/dashboard/type-mapping');
  };

  // Check if user is admin
  const isAdmin = (): boolean => {
    const role = orgService.getRole();
    return role === 'admin';
  };

  // Check if user is administrator (super admin)
  const isAdministrator = (): boolean => {
    const role = orgService.getRole();
    return role === 'administrator';
  };

  return (
    <header className="header">
      <div className="header-left">
        <div className="royal-cyber-logo">
          <img 
            src="/Royal-Cyber-Logo-2%201.svg" 
            alt="Royal Cyber Logo" 
            width="119" 
            height="29"
          />
        </div>
        <div className="separator"></div>
        <div className="app-title">SCM Migration</div>
      </div>
      
      <div className="header-right">
        {/* <div className="notifications">
          <div className="bell-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" fill="currentColor"/>
            </svg>
            <div className="notification-badge">3</div>
          </div>
        </div> */}
        
        <div className="user-menu" ref={userMenuRef} onClick={toggleUserDropdown}>
          <span className="user-name">Admin</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 10l5 5 5-5z" fill="currentColor"/>
          </svg>
          {showUserDropdown && (
            <div className="user-dropdown">
              {/* <div className="dropdown-item">Profile</div> */}
              {isAdministrator() && (
                <div className="dropdown-item" onClick={handleManageOrganizations}>Manage Organizations</div>
              )}
              {isAdmin() && (
                <div className="dropdown-item" onClick={handleUserManagement}>Manage Users</div>
              )}
              {isAdmin() && (
                <div className="dropdown-item" onClick={handleTypeMapping}>Type Mapping</div>
              )}
              {!isAdministrator() && (
                <div className="dropdown-item" onClick={handleSettings}>Settings</div>
              )}
              <div className="dropdown-item" onClick={handleChangePassword}>Change Password</div>
              <div className="dropdown-item" onClick={handleLogout}>Logout</div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
